import React from 'react';
import Swal from 'sweetalert2';
import { Link } from "react-router-dom";
import authAxios from "../../services/Token";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAt, faGlobe, faHashtag, faSave, faTimes } from '@fortawesome/free-solid-svg-icons';

class Crear extends React.Component {
    constructor(props) {
        super(props);
    }
    state = {
        name: '',
        address: '',
        phone: '',
        website: '',
        email: '',
        postal_code: '',
        full_name_billing: '',
        address_billing: '',
        phone_billing: '',
        tax_number_billing: '',
        errors: [],
    }
    changeValue = (e) => {
        const state = this.state;
        state[e.target.name] = e.target.value;
        this.setState({ state, errors: [] })
    }
    errorVerify(element) {
        return this.state.errors.indexOf(element) !== -1;
    }
    sendData = (e) => {
        e.preventDefault();
        const { name, address, phone, website, email, postal_code, full_name_billing, address_billing, phone_billing, tax_number_billing } = this.state;
        var errors = [];
        if (!name) { errors.push("error_name"); }
        if (!address) { errors.push("error_address"); }
        if (!email) { errors.push("error_email"); }
        if (!postal_code) { errors.push("error_postal_code"); }
        if (!full_name_billing) { errors.push("error_full_name_billing"); }
        if (!address_billing) { errors.push("error_address_billing"); }
        if (!phone_billing) { errors.push("error_phone_billing"); }
        if (!tax_number_billing) { errors.push("error_tax_number_billing"); }
        console.log(errors.length);
        this.setState({ errors: errors });
        if (errors.length > 0) {
            return false;
        }
        var data = {
            name: name,
            address: address,
            phone: phone,
            website: website,
            email: email,
            postal_code: postal_code,
            full_name_billing: full_name_billing,
            address_billing: address_billing,
            phone_billing: phone_billing,
            tax_number_billing: tax_number_billing,
            user_id: window.localStorage.getItem('idusuario')
        }
        Swal.showLoading();
        authAxios.post("suppliers/register", data)
            .then((dataResult) => {
                console.log(dataResult)
                var status = dataResult.data.status;
                if (status) {
                    Swal.close();
                    Swal.fire('Token has Expired!', 'Re-Login', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }
                if (dataResult.data.Status) {
                    Swal.close();
                    Swal.fire(
                        'Suppliers!',
                        dataResult.data.msj,
                        'success'
                    )
                    this.props.history.push("/MasterSuppliers");
                } else {
                    Swal.close();
                    Swal.fire(
                        'Suppliers!',
                        dataResult.data.msj,
                        'error'
                    )
                }
            })
            .catch(console.log)
    }
    render() {
        const { name, address, phone, website, email, postal_code, full_name_billing, address_billing, phone_billing, tax_number_billing } = this.state;
        return (
            <div className="content-wrapper">
                <div className="content">
                    <div className="container-fluid">
                        <br />
                        <div className="card">
                            <div className="card-header text-center">
                                <b>NEW SUPPLIER</b>
                            </div>
                            <div className="card-body">
                                <form onSubmit={this.sendData}>
                                    <div className="row">
                                        <div className="col-xl-12">
                                            <hr style={{ marginBottom: 0, marginTop: 0 }} />
                                            <div style={{ fontSize: 14 }} className="card-header text-center">
                                                <b>SUPPLIER INFORMATION</b>
                                            </div>
                                            <div style={{ marginTop: 0 }} className='row g-3'>
                                                <div className="col-md-5">
                                                    <label htmlFor="name">Name</label>
                                                    <input style={{ textTransform: 'uppercase' }} className={((this.errorVerify("error_name")) ? "is-invalid" : "") + " form-control form-control-sm"} type="text" name="name" id="name" value={name} placeholder="Name" aria-describedby="helpId" onChange={this.changeValue} />
                                                    <small id="helpId" className="invalid-feedback">Please enter Supplier Name</small>
                                                </div>
                                                <div className="col-md-4">
                                                    <label htmlFor="address">Address</label>
                                                    <input style={{ textTransform: 'uppercase' }} className={((this.errorVerify("error_address")) ? "is-invalid" : "") + " form-control form-control-sm"} type="text" name="address" id="address" value={address} placeholder="Address" aria-describedby="helpId" onChange={this.changeValue} />
                                                    <small id="helpId" className="invalid-feedback">Please enter Supplier Address</small>
                                                </div>
                                                <div className="col-md-3">
                                                    <label htmlFor="phone">Phone</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faHashtag} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} className={((this.errorVerify("error_phone")) ? "is-invalid" : "") + " form-control form-control-sm"} type="text" name="phone" id="phone" value={phone} placeholder="Phone" aria-describedby="helpId" onChange={this.changeValue} />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Please enter Supplier Phone</small>
                                                </div>
                                            </div>
                                            <div style={{ marginTop: 0 }} className='row g-3'>
                                                <div className="col-md-5">
                                                    <label htmlFor="website">Website</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faGlobe} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} className={((this.errorVerify("error_website")) ? "is-invalid" : "") + " form-control form-control-sm"} type="text" name="website" id="website" value={website} placeholder="Website" aria-describedby="helpId" onChange={this.changeValue} />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Please enter Supplier Website</small>
                                                </div>
                                                <div className="col-md-4">
                                                    <label htmlFor="email">Email</label>
                                                    <div className={((this.errorVerify("error_email")) ? "is-invalid" : "") + " input-group input-group-sm"}>
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faAt} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} className={((this.errorVerify("error_email")) ? "is-invalid" : "") + " form-control form-control-sm"} type="text" name="email" id="email" value={email} placeholder="Email" aria-describedby="helpId" onChange={this.changeValue} />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Please enter Supplier Email</small>
                                                </div>
                                                <div className="col-md-3">
                                                    <label htmlFor="postal_code">Postal Code</label>
                                                    <div className={((this.errorVerify("error_postal_code")) ? "is-invalid" : "") + " input-group input-group-sm"}>
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faHashtag} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} className={((this.errorVerify("error_postal_code")) ? "is-invalid" : "") + " form-control form-control-sm"} type="text" name="postal_code" id="postal_code" value={postal_code} placeholder="Postal Code" aria-describedby="helpId" onChange={this.changeValue} />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Please enter Supplier Postal Code</small>
                                                </div>
                                            </div>
                                            <hr style={{ marginBottom: 0 }} />
                                            <div style={{ fontSize: 14 }} className="card-header text-center">
                                                <b>BILLING INFORMATION</b>
                                            </div>
                                            <div style={{ marginTop: 0 }} className='row g-3'>
                                                <div className="col-md-3">
                                                    <label htmlFor="full_name_billing">Full Name</label>
                                                    <input style={{ textTransform: 'uppercase' }} className={((this.errorVerify("error_full_name_billing")) ? "is-invalid" : "") + " form-control form-control-sm"} type="text" name="full_name_billing" id="full_name_billing" value={full_name_billing} placeholder="Full Name" aria-describedby="helpId" onChange={this.changeValue} />
                                                    <small id="helpId" className="invalid-feedback">Please enter Full Name</small>
                                                </div>
                                                <div className="col-md-3">
                                                    <label htmlFor="address_billing">Address</label>
                                                    <input style={{ textTransform: 'uppercase' }} className={((this.errorVerify("error_address_billing")) ? "is-invalid" : "") + " form-control form-control-sm"} type="text" name="address_billing" id="address_billing" value={address_billing} placeholder="Address" aria-describedby="helpId" onChange={this.changeValue} />
                                                    <small id="helpId" className="invalid-feedback">Please enter Address</small>
                                                </div>
                                                <div className="col-md-3">
                                                    <label htmlFor="phone_billing">Phone</label>
                                                    <div className={((this.errorVerify("error_phone_billing")) ? "is-invalid" : "") + " input-group input-group-sm"}>
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faHashtag} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} className={((this.errorVerify("error_phone_billing")) ? "is-invalid" : "") + " form-control form-control-sm"} type="text" name="phone_billing" id="phone_billing" value={phone_billing} placeholder="Phone" aria-describedby="helpId" onChange={this.changeValue} />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Please enter Phone</small>
                                                </div>
                                                <div className="col-md-3">
                                                    <label htmlFor="tax_number_billing">Tax Number</label>
                                                    <div className={((this.errorVerify("error_tax_number_billing")) ? "is-invalid" : "") + " input-group input-group-sm"}>
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faHashtag} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} className={((this.errorVerify("error_tax_number_billing")) ? "is-invalid" : "") + " form-control form-control-sm"} type="text" name="tax_number_billing" id="tax_number_billing" value={tax_number_billing} placeholder="Tax Number" aria-describedby="helpId" onChange={this.changeValue} />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Please enter Tax Number</small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <hr />
                                    <div className='row'>
                                        <div className='col-xl-12 text-center'>
                                            <div className="btn-group" role="group" aria-label="">
                                                <button type="submit" className="btn btn-success btn-sm"><FontAwesomeIcon icon={faSave} />&nbsp;&nbsp;Save</button>&nbsp;&nbsp;
                                                <Link className="btn btn-danger btn-sm" to={"/MasterSuppliers"}><FontAwesomeIcon icon={faTimes} />&nbsp;&nbsp;Cancel</Link>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Crear;